export default "__VITE_ASSET__BvX9AImo__"